import Components from "slotworks/components/components";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import BetMenuMediator from "slotworks/mediators/bet-menu-mediator";
import Gamestate from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import SmartButton from "slotworks/smart-button/smart-button";
import Contract from "slotworks/utils/contract";
import DSComponents from "components/components";
import Layers from "slotworks/graphics/layers/layers";
import State from "slotworks/state-machine/states/state";
import { parallel, sequence } from "slotworks/utils/race-utils";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Bet from "slotworks/model/bets/bet-model";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import soundManager from "slotworks/sound/sound-manager";
import Logger = require("js-logger");
import betModel from "slotworks/model/bets/bet-model";
import ShowPromoFSafterFreespins from "slotworks/commands/promo-free-spins/show-pfs-after-freespins";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import deviceInfo from "slotworks/utils/device-info";
import EnterFreespinsTransition from "transitions/enter-freespins-transitions";


// probably mediator will be good, for now I will just add the component calling here
export default class ICExitFreespins extends State {

    protected summaryScenes: string[] = ["freespinssummary", "freespins"];
    protected promptContents: Map<string, string>;

    private prompt: PromptContent;

    public onEnter() {
        //    SmartButton.setFlag(SmartButtonFlag.PROMPT, true);
        this.startFreespinsBigWin().then(bigWin => {
            deviceInfo.onLayoutChange.remove(EnterFreespinsTransition.startTorch);
            EnterFreespinsTransition.clearTorchTweens();
            Layers.Custom.get("Torches").defaultScene().execute();

            if (bigWin) {
                // Layers.PromoBetBar.show();
                // Layers.SmartButton.show();
                this.afterPrompt().then(() => this.complete());
            } else {
                this.showPromptWin().then(() => this.complete());
            }
        })
    }

    protected showPromptWin(): Contract<void> {
        return new Contract<void>(resolve => {
            this.prompt = null;
            this.promptContents = new Map<string, string>();
            sequence([
                () => this.setupPrompt(),
                () => this.showPrompt(),
                () => this.afterPrompt()
            ]).then(() => {
                resolve(null);
            });
        });
    }

    // mediator part, not really needed to be mediator
    protected startFreespinsBigWin(): Contract<boolean> {
        const freeSpinsWin = this.getCreditsWon();
        const stake = Bet.getTotalBet();
        return DSComponents.freespinsBigWin.showWin(freeSpinsWin, stake);
    }

    public complete() {
        Gamestate.getCurrentGame().inFreespinsGame = false;
        regulation.updateNetPosition(Gamestate.getNetPosition());
        this.setWinnings();
        super.complete();
        DSComponents.jackpotMeter.setJackpot(betModel.getTotalBet());
    }

    private getCreditsWon() {
        const freeSpinsWin = Gamestate.getCurrentGame().getRunningFreespinsWinTotal();
        if (freeSpinsWin)
            return freeSpinsWin;
        return Gamestate.getCurrentGame().totalCreditsWon;
    }

    protected setupPrompt() {
        return Contract.wrap(() => {

            if (Layers.CelebrationBackground.hasScene("glowstack")) {
                Layers.CelebrationBackground.setScene("glowstack").execute();
            }

            SmartButton.setFlag(SmartButtonFlag.PROMPT, true);

            const freeSpinsWin = this.getCreditsWon();
            let message;
            let summaryScene;
            let time = 3500;
            let noWin: boolean;
            if (freeSpinsWin > 0) {
                //    message = translations.get("fs.wsu", { VALUE: freeSpinsWin });
                summaryScene = "freespinssummary";
                noWin = false;
            } else {
                //    message = translations.get("fs.nws");
                summaryScene = "freespinsnowin";
                time = 500;
                noWin = true;
            }

            const freespinsRecord = Gamestate.getCurrentGame().getCurrentRecord() as FreespinRecord;
            //    const freespinsPlayed = freespinsRecord.totalFreespins.toString();

            this.prompt = new PromptContent([summaryScene, ...this.summaryScenes], time);
            if (!noWin) this.prompt.addContinueButton("continue");

            // this.promptContents.set("winMessage", message);
            // this.promptContents.set("played", freespinsPlayed);
            this.prompt.addText(this.promptContents);

            this.prompt.countupText("value", freeSpinsWin, 3000);
        });
    }

    protected showPrompt(): Contract<void> {
        soundManager.customEvent("free_spins_results");
        return Components.prompt.showPrompt(this.prompt);

    }

    protected afterPrompt() {
        return parallel([
            () => Contract.wrap(() => {
                SmartButton.setFlag(SmartButtonFlag.PROMPT, false);
            }),
            () => this.hideFreespinsComponents(),
            () => this.resetToTriggeringSpin()
        ]);
    }

    protected hideFreespinsComponents(): Contract<void> {
        return parallel([
            () => Layers.Background.defaultScene(),
            () => Layers.MatrixBackground.defaultScene(),
            () => Layers.Header.defaultScene(),
            () => Contract.wrap(() => Components.banner.setMode("default")),
            () => Contract.wrap(() => Components.footer.showDefaultText())
        ]);
    }

    protected setWinnings(): void {
        const totalWin = Gamestate.getCurrentGame().totalCreditsWon;
        Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);
    }

    protected showTriggeringSpinWin(totalWin: number, triggeringWin: number) {
        const isBigWin = Components.bigWin.isBigWin(totalWin, Bet.getTotalBet());

        if (!isBigWin) {
            Components.betBar.winnings.setWinnings(triggeringWin);
        }
    }

    protected resetToTriggeringSpin() {
        return Contract.wrap(() => {
            const freeSpinsWin = Gamestate.getCurrentGame().getRunningFreespinsWinTotal();

            SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, false);
            SmartButton.setFlag(SmartButtonFlag.PROMPT, false);

            if (campaignsModel.isFreespinsActive()) {
                ShowPromoFSafterFreespins();
            } else {
                Layers.BetBar.show();
            }
            Layers.SmartButton.show();
            Components.betBar.setType(BetBarType.DEFAULT);
            Components.betBar.setEnabled(false);

            const betMenuMediator = new BetMenuMediator();
            betMenuMediator.start().execute();
            betMenuMediator.end();

            const record = Gamestate.getCurrentGame().resetRecordIndex() as SpinRecord;

            const triggeringWin: number = record.creditsWon;

            record.creditsWon += freeSpinsWin;
            record.beenPaid = true;

            this.showTriggeringSpinWin(record.creditsWon, triggeringWin);

            Components.matrix.clearStuckSymbols();

            DSComponents.coinPots.restoreBankedCoinsAfterFreespin();

            // Can't reset reels during recovered game
            if (!Gamestate.getCurrentGame().isRecovered) {
                Components.matrix.jumpToGrid(record.grid);
                // if (record.stops) {
                //     Components.matrix.jump(record.stops, record.reelset);
                // } else {
                //     Components.matrix.jumpToGrid(record.grid);
                // }
            }
        });
    }

    public onExit() {
        Layers.CelebrationBackground.setScene("default").execute();
        soundManager.customEvent('base_reels_background_start');
        super.onExit();
    }

}
